<template>
  <div class="card">
    <div class="card-header">
      <DatePicker @onChange="onTabChange" @onDateChange="onDateChange" />
      <span>- 分销邀请人数</span>
    </div>
    <div class="card-content">
      <div class="card-chart">
        <ve-line
          :data="chartData"
          :extend="extend"
          :settings="settings"
        ></ve-line>
      </div>
      <div class="card-table">
        <div class="card-table-title">分销扩展人数排名</div>
        <el-table :data="rankData" style="width: 100%">
          <el-table-column prop="order" label="排名">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="昵称"> </el-table-column>
          <el-table-column prop="customerCount" label="扩展人数">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import * as saleStatistics from '@/api/saleStatistics'
import DatePicker from '../common/datePicker'
import { getDateRange, fmtDataRange } from '../common/helper'

export default {
  components: {
    DatePicker
  },
  data () {
    return {
      rankData: [],
      settings: {
        labelMap: {
          customerCount: '邀请客户数'
        }
      },
      chartData: {
        columns: ['date', 'customerCount'],
        rows: []
      },
      extend: {
        color: ['#3270FF'],
        legend: {
          show: false
        }
      }
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData (date = 30) {
      const res = await saleStatistics.customerByDay(getDateRange(date))
      this.handleData(res)
    },
    async getRankData (date = 30) {
      this.rankData = await saleStatistics.rank(getDateRange(date))
    },
    onTabChange (val) {
      this.fetchData(val)
      this.getRankData(val)
    },
    async onDateChange (data) {
      const res = await saleStatistics.customerByDay(fmtDataRange(data))
      this.handleData(res)
      this.rankData = await saleStatistics.rank(fmtDataRange(data))
    },
    handleData (data) {
      this.chartData.rows = data
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  background-color: #ffffff;
  height: 550px;
  margin: 20px auto;
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    border-bottom: 1px solid #d9e0f0;

    span {
      color: #999999;
      margin-right: 20px;
    }
  }

  &-content {
    width: 100%;
    display: grid;
    grid-template-columns: 2fr 1fr;
  }

  &-chart {
    &-title {
      margin-top: -20px;
      height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #7d7e8e;
      line-height: 25px;
    }
    border-right: 1px solid #d9e0f0;
  }

  &-table {
    max-height: 440px;
    padding: 20px;
    overflow: auto;
    &-title {
      text-align: left;
      height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #7d7e8e;
      line-height: 25px;
      &:before {
        content: "";
        background: #1d90fbff;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 8px;
        margin-bottom: 5px;
      }
    }
  }
}

.tooltip {
  display: flex;
  align-items: center;
  margin-right: 30px;
  span {
    margin-left: 5px;
  }
}
</style>
